<template>
  <f-filter-bar
    v-if="optionsLoaded"
    data-testid="staff-table-options"
    @update:model-value="filterResults"
  >
    <f-filter-bar-multiselect
      title="Permission Groups"
      name="permission-groups"
      data-testid="filter-multiselect"
    >
      <f-filter-bar-multiselect-option
        v-for="option in filterOptions[1].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-multiselect-option"
      />
    </f-filter-bar-multiselect>
    <f-filter-bar-multiselect
      v-if="!isArchived"
      title="Compliant"
      name="compliant"
      data-testid="filter-multiselect"
    >
      <f-filter-bar-multiselect-option
        v-for="option in filterOptions[3].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-multiselect-option"
      />
    </f-filter-bar-multiselect>

    <f-filter-bar-category
      title="Job Role"
      name="roles"
      data-testid="filter-category"
    >
      <f-filter-bar-option
        v-for="option in filterOptions[0].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-category-option"
      />
    </f-filter-bar-category>
    <f-filter-bar-category
      title="Permission Group"
      name="permission-groups"
      data-testid="filter-category"
    >
      <f-filter-bar-option
        v-for="option in filterOptions[1].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-category-option"
      />
    </f-filter-bar-category>
    <f-filter-bar-category
      v-if="!isArchived"
      title="Compliant"
      name="compliant"
      data-testid="filter-category"
    >
      <f-filter-bar-option
        v-for="option in filterOptions[3].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-category-option"
      />
    </f-filter-bar-category>
    <f-filter-bar-category
      v-if="!isArchived"
      title="Login Access"
      name="login-access"
      data-testid="filter-category"
    >
      <f-filter-bar-option
        v-for="option in filterOptions[2].options"
        :key="option"
        :value="option.value"
        :title="option.title"
        data-testid="filter-category-option"
      />
    </f-filter-bar-category>
  </f-filter-bar>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useFilterResults } from "../use-filter-results/use-filter-results";
import { useFetch } from "@vueuse/core";

export default defineComponent({
  name: "StaffTableOptions",
  props:{
    optionsEndpointUrl:{
      type: String,
      default: "",
      required: true
    },
    isArchived:{
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const optionsLoaded = ref(false);
    const filterOptions = ref({});
    const filterOptionsUrl = ref(props.optionsEndpointUrl);
    const { filterResults } = useFilterResults(emit);
    const fetchOptions = async () => {
      const { error, data } = await useFetch(filterOptionsUrl).json();

      if(error?.value){
        console.error("There was an issue fetching the filter options:", error.value); // eslint-disable-line
      }

      if(data?.value){
        filterOptions.value = data.value.data;
        optionsLoaded.value = true;
      }

    };

    fetchOptions();
    
    return {
      filterResults,
      filterOptions,
      optionsLoaded
    };
  }
});
</script>

<style lang="scss" scoped>
:deep(.static-bar){
  display: flex;
}
</style>

